/**
 * External dependencies
 */
import React from "react";

const EmptyPosts = ({
	title = "Couldn't find any posts matching your filters.",
	text = "",
}) => {
	return (
		<>
			<h3>{title}</h3>
			{!!text && <p>{text}</p>}
		</>
	);
};

export default EmptyPosts;
